import React from 'react';
import { SelectValueViewer } from 'components';
import { OwnershipValueViewerProps } from './OwnershipValueViewer.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const OwnershipValueViewer = (props: OwnershipValueViewerProps) => {
  const { ownershipOptions } = useCashFlowContext();

  return <SelectValueViewer {...props} options={ownershipOptions} />;
};

export default OwnershipValueViewer;
